import Alpine from 'alpinejs';

Alpine.store('modals', {
    openModals: [],

    getDialogElement(val) {
        // If already an element, return it
        if (val instanceof HTMLDialogElement) {
            return val;
        }

        // If string, assume it's an ID
        return document.getElementById(val) ?? null;
    },

    open(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        if (modal.open) return;

        modal.showModal();
        this.openModals = [
            ...this.openModals.filter((m) => m !== modal),
            modal
        ];
        modal.dispatchEvent(
            new CustomEvent('modal:open', {
                bubbles: true,
                detail: { id: modal.id }
            })
        );
    },

    close(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        if (modal.open) {
            modal.close();
        }
        this.openModals = this.openModals.filter((m) => m !== modal);
    },

    closeAll() {
        // Query the DOM as well as the store so dialogs opened outside this
        // store cannot remain stacked beneath the next modal.
        const openDialogs = new Set([
            ...this.openModals,
            ...document.querySelectorAll('dialog[open]')
        ]);

        let closedCount = 0;

        openDialogs.forEach((modal) => {
            if (modal instanceof HTMLDialogElement && modal.open) {
                modal.close();
                closedCount += 1;
            }
        });

        this.openModals = [];

        return closedCount;
    },

    replace(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        const openDialogs = document.querySelectorAll('dialog[open]');
        if (modal.open && openDialogs.length === 1) return;

        const closedCount = this.closeAll();

        if (closedCount > 0) {
            const modalTarget = modal.id || modal;
            window.setTimeout(() => this.open(modalTarget), 250);
            return;
        }

        this.open(modal);
    },

    markAsSuccess(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        modal.classList.add('is-success');

        setTimeout(() => {
            modal.classList.remove('is-success');
        }, 2500);
    },

    markAsError(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        modal.classList.add('is-error');
    }
});
